<template>
    <div ref="template">
        <cogi-popup-yes-no ref="popupPieceJustificative">
            <div style="padding: 50px 50px 0px 50px; text-align: center">
                <p>{{ $t('AvertissementAucunePieceJustificativePartie1') }}</p>
                <p>{{ $t('AvertissementAucunePieceJustificativePartie2') }}</p>
            </div>
        </cogi-popup-yes-no>

        <div class="cogi-subtitle">
            <cogi-label-only label="PiecesJustificativesAJoindre" />
            <cogi-info id="infoPieceJustificative" :dontTranslate="true" :tooltip="tooltipPiecesJustificatives"></cogi-info>
        </div>

        <p v-html="$t('ExplicationPieceJustificative', [model.dicUrlDocumentPiecesJustificatives![model.culture ?? 'fr']])"></p>
        <p>{{ $t('PreuvesObligatoires') }}</p>

        <div class="grid">
            <CogiListePersonnes class="gridspan11" :personnes="getPersonnes()" />
            <cogi-fileupload class="gridspan5 verticalCenter center" v-model="files" />

            <hr class="grid-full" />

            <CogiListeFichiers
                class="grid-full"
                v-model="files"
                :afficherFichierExtensionInvalide="afficherFichierExtensionInvalide"
                :afficherFichierNomTropLong="afficherFichierNomTropLong"
                :fichierJointMaxLongueurNom="longueurNomFichierMaximum"
                :afficherFichierTailleInvalide="afficherFichierTailleInvalide"
                :fichierJointMaxBytes="tailleFichiersMaximum"
                :afficherFichiersTailleInvalide="afficherFichiersTailleInvalide"
                @delete="onDeleteFile" />
        </div>

        <div class="cogi-subtitle">
            <cogi-label-only label="Commentaires" />
        </div>

        <div class="grid">
            <cogi-label cssClass="grid-full" label="SiVotreConditionNecessiteUnSoutient"></cogi-label>
            <textarea class="grid-full" cols="50" rows="10" v-model="model.encadrementNecessaire"></textarea>

            <cogi-label cssClass="grid-full" label="PourToutAutreInformationRelativeAVotreDemande" />
            <ul class="grid-full">
                <li>{{ $t('ExempleInformationRelativePoint1') }}</li>
                <li>{{ $t('ExempleInformationRelativePoint2') }}</li>
                <li>{{ $t('ExempleInformationRelativePoint3') }}</li>
                <li>{{ $t('ExempleInformationRelativePoint4') }}</li>
                <li>{{ $t('ExempleInformationRelativePoint5') }}</li>
            </ul>
            <textarea class="grid-full" cols="50" rows="10" v-model="model.autreCommentaire"></textarea>
        </div>

        <cogi-yesno
            cssClass="cogi-subtitle"
            @validated="validated"
            :valideNow="valideNow"
            :required="true"
            v-model="etesVousDemandeur"
            label="CompletezVousCetteDemandePourUneTiercePersonne"></cogi-yesno>

        <div class="grid">
            <cogi-regex
                cssClass="grid-half"
                :visible="showPanelTiercePersonne"
                @validated="validated"
                :valideNow="valideNow"
                label="VotrePrenom"
                :required="true"
                v-model="model.prenomDemandeurPour"></cogi-regex>
            <cogi-regex
                cssClass="grid-half"
                :visible="showPanelTiercePersonne"
                @validated="validated"
                :valideNow="valideNow"
                label="VotreNom"
                :required="true"
                v-model="model.nomDemandeurPour"></cogi-regex>
            <cogi-dropdownlist
                cssClass="grid-half"
                :culture="model.culture!"
                :visible="showPanelTiercePersonne"
                class="grid-half"
                @validated="validated"
                :valideNow="valideNow"
                label="VotreLienAvecLeDemandeur"
                :required="true"
                :showEmptyItem="true"
                v-model="model.lienDemandeurPour"
                :sourceItems="sourceItemLienDemandeur"></cogi-dropdownlist>
            <cogi-telephone
                cssClass="grid-half"
                :required="true"
                :visible="showPanelTiercePersonne"
                @validated="validated"
                label="VotreTelephone"
                v-model="model.telephoneDemandeurPour"
                :valideNow="valideNow"></cogi-telephone>
            <cogi-email
                cssClass="grid-half"
                :visible="showPanelTiercePersonne"
                label="VotreAdresseCourriel"
                v-model="model.courrielDemandeurPourEmail"></cogi-email>
            <cogi-label
                v-show="showPanelTiercePersonne"
                cssClass="gridspan13"
                cssClassLabel="text-plus-gros"
                label="JeConfirmeAvoirEuLautorisation"></cogi-label>
            <cogi-checkbox
                cssClass="gridspan3 gras"
                :required="true"
                :visible="showPanelTiercePersonne"
                @validated="validated"
                :valideNow="valideNow"
                label="JAccepte"></cogi-checkbox>
        </div>

        <div class="cogi-subtitle">
            <cogi-label-only label="AttestationEtAutorisationDeVerification" />
        </div>

        <div class="grid">
            <cogi-label cssClass="gridspan13" cssClassLabel="text-plus-gros" label="JeCertifieQueLesRenseignementSontVeridiques"></cogi-label>
            <cogi-checkbox
                cssClass="gridspan3 gras"
                :required="true"
                @validated="validated"
                :valideNow="valideNow"
                label="JAccepte"
                v-model="model.accepteRenseignements"></cogi-checkbox>
            <hr class="grid-full" />
            <cogi-label cssClass="gridspan13" cssClassLabel="text-plus-gros" :dontTranslate="true" :label="getDescriptionOffice()"></cogi-label>
            <cogi-checkbox
                cssClass="gridspan3 gras"
                :required="true"
                @validated="validated"
                :valideNow="valideNow"
                label="JAccepte"
                v-model="model.accepteVerificationsOmh"></cogi-checkbox>
            <hr class="grid-full" />
            <cogi-label cssClass="grid-full" cssClassLabel="text-plus-gros" label="TouteDeclarationFausseOuTrompeuse"></cogi-label>
        </div>

        <div class="grid">
            <cogi-button cssClass="gridspan15 right" cssClassButton="precedent" text="EtapePrecedente" @click="precedent"></cogi-button>
            <cogi-button cssClass="gridspan1 right" cssClassButton="suivant" text="SoumettreVotreDemande" @click="soumettreclick"></cogi-button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, watch, computed, getCurrentInstance, useTemplateRef } from 'vue'
    import { ValidatorAccumulatorVueComponent, ValidatorAccumulator, ValidationStatutPoco } from './helpers/validatorAccumulator'
    import CogiRegex from './CogiRegex.vue'
    import CogiDropdownlist from './CogiDropdownlist.vue'
    import CogiLabel from './CogiLabel.vue'
    import CogiButton from './CogiButton.vue'
    import CogiLabelOnly from './CogiLabelOnly.vue'
    import CogiTelephone from './CogiTelephone.vue'
    import CogiInfo from './CogiInfo.vue'
    import CogiCheckbox from './CogiCheckbox.vue'
    import CogiYesno from './CogiYesno.vue'
    import CogiEmail from './CogiEmail.vue'
    import CogiFileupload from './CogiFileupload.vue'
    import CogiPopupYesNo from './popup/CogiPopupYesNo.vue'
    import { del } from '../../../clients/delclient'
    import type DemandeEnLigneVM from '../DemandeEnLigneVM'
    import CogiListePersonnes from './CogiListePersonnes.vue'
    import CogiListeFichiers from './CogiListeFichiers.vue'
    import { useI18n } from 'vue-i18n'
    const i18n = useI18n()

    const extentionsValide = [
        'pdf',
        'xls',
        'doc',
        'dot',
        'docx',
        'dotx',
        'docm',
        'dotm',
        'xlt',
        'xla',
        'xlsx',
        'xltx',
        'xlsm',
        'xltm',
        'xlam',
        'xlsb',
        'ppt',
        'pot',
        'pps',
        'ppa',
        'pptx',
        'potx',
        'ppsx',
        'ppam',
        'pptm',
        'potm',
        'ppsm',
        'wav',
        'jpg',
        'jpeg',
        'gif',
        'png',
        'heic',
    ]

    interface IPropsCogiEtape5 {
        sourceItemPointServices: del.ListItem[]
        sourceItemLienDemandeur: del.ListItem[]
    }

    defineProps<IPropsCogiEtape5>()
    const model = defineModel<DemandeEnLigneVM>({ required: true })

    const validatorAccumulator = ref(new ValidatorAccumulatorVueComponent(new ValidatorAccumulator()))
    const hasError = ref(false)
    const popupPieceJustificative = useTemplateRef('popupPieceJustificative')
    const etesVousDemandeur = ref(undefined)
    const showPanelTiercePersonne = ref(false)
    const valideNow = ref(false)
    const isInsuivantMode = ref(false)
    const validateCallback = ref(defaultValidateCallback)

    const files = defineModel<Array<File>>('files')

    const afficherFichierExtensionInvalide = ref(false)
    const afficherFichierTailleInvalide = ref(false)
    const afficherFichiersTailleInvalide = ref(false)
    const afficherFichierNomTropLong = ref(false)

    const emit = defineEmits<{
        reculerUnEtape: [number]
        soumettre: [number]
    }>()

    const tailleFichiersMaximum = computed(
        () => model.value.fichiersJointsMaxBytes ?? 41943040, // 40 MB
    )

    const tailleTotaleFichiersMaximum = 100000000 // 100MB

    const longueurNomFichierMaximum = computed(() => model.value.fichierJointMaxLongueurNom ?? 104)

    const tooltipPiecesJustificatives = computed(() => {
        return (
            i18n.t('PourConnaitreLaListeDesPiecesJustificatives') +
            "<a target='_blank' href='" +
            model.value.dicUrlDocumentPiecesJustificatives!['fr'] +
            "'> " +
            i18n.t('ConsulterCeDocument') +
            '</a>'
        )
    })

    const nomOrganisme = computed(() => {
        return model.value.dicNomOrganisme![model.value.culture!]
    })

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function defaultValidateCallback(hasError: boolean) {}

    function getDescriptionOffice() {
        return i18n.t('JAutorise') + ' ' + nomOrganisme.value + ' ' + i18n.t('AEffectuerToutesLesVerifications')
    }

    function precedent() {
        emit('reculerUnEtape', 4)
    }
    const instance = getCurrentInstance()

    function validate() {
        hasError.value = false

        // if (!model.value.pointService || !etesVousDemandeur.value) {
        //     hasError.value = true
        // }

        valideNow.value = validatorAccumulator.value.startValidation(instance)
    }

    async function validerPieceJustificative(): Promise<boolean> {
        if ((files.value?.length ?? 0) > 0) {
            return true
        }

        return (await popupPieceJustificative.value?.showDialog()) ?? true
    }

    function validated(newValue: boolean) {
        let validationStatut: ValidationStatutPoco = validatorAccumulator.value.validated(newValue)

        if (!validationStatut.validationCompleted) return

        hasError.value = validationStatut.hasError
        valideNow.value = false

        soumettreValiderPieces()
        validateCallback.value(hasError.value)
        validateCallback.value = defaultValidateCallback
    }

    async function soumettreclick() {
        isInsuivantMode.value = false
        validate()
    }

    async function soumettreValiderPieces() {
        if (!validerFichiers()) return

        if (isInsuivantMode.value) {
            soumettre()
        } else if (!hasError.value) {
            validerPieceJustificative().then(continuer => {
                if (continuer) {
                    isInsuivantMode.value = true
                    validate()
                }
            })
        }
    }

    function soumettre() {
        if (!isInsuivantMode.value) return

        isInsuivantMode.value = false
        if (hasError.value) return
        else emit('soumettre', 5)
    }

    function getPersonnes() {
        let personnes: del.PersonneModel[] = []

        personnes.push(new del.PersonneModel({ prenom: model.value.prenom, nom: model.value.nom }))
        model.value.persons?.forEach(personne => personnes.push(personne))

        return personnes
    }

    watch(files, () => validerFichiers(), { deep: true })

    function validerFichiers(): boolean {
        afficherFichierExtensionInvalide.value = false
        afficherFichierTailleInvalide.value = false
        afficherFichierNomTropLong.value = false

        let tailleTotale = files.value?.map(f => f.size).reduce((total, s) => total + s, 0) ?? 0
        let tailleValide = tailleTotale <= tailleTotaleFichiersMaximum
        afficherFichiersTailleInvalide.value = !tailleValide

        return tailleValide && (files.value?.every(f => validerFichier(f)) ?? true)
    }

    function validerFichier(file: File): boolean {
        let estValide: boolean = true

        if (!isExtensionValide(file.name)) {
            afficherFichierExtensionInvalide.value = true
            estValide = false
        }

        if (file.size > tailleFichiersMaximum.value) {
            afficherFichierTailleInvalide.value = true
            estValide = false
        }

        if (file.name.length > longueurNomFichierMaximum.value) {
            afficherFichierNomTropLong.value = true
            estValide = false
        }

        return estValide
    }

    function onDeleteFile(index: number) {
        //validerFichiers
        files.value!.splice(index, 1)
    }

    function isExtensionValide(filename: string) {
        const matchs = filename.match(/\.([^.]+)$/)
        if (matchs === null || matchs.length < 1) return false
        const ext = matchs[1].toLocaleLowerCase()
        return extentionsValide.includes(ext)
    }

    watch(
        () => etesVousDemandeur.value,
        newValue => {
            showPanelTiercePersonne.value = newValue == '1'
        },
    )

    defineExpose({ validate, hasError, validateCallback })
</script>
